import { render, staticRenderFns } from "./SkuDetailOld.vue?vue&type=template&id=cbd16220&scoped=true"
import script from "./SkuDetailOld.vue?vue&type=script&lang=js"
export * from "./SkuDetailOld.vue?vue&type=script&lang=js"
import style0 from "./SkuDetailOld.vue?vue&type=style&index=0&id=cbd16220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd16220",
  null
  
)

export default component.exports